import * as v from 'valibot';

const zeroOrOne = v.union([v.literal(0), v.literal(1)]);

const extendsSchema = v.object({
  postTitle: v.string(),
  postSlug: v.string(),
  postId: v.number(),
  postType: v.string(),
  title: v.string(),
  renderTitle: v.string(),
  commentUserName: v.string(),
  eventName: v.string(),
  code: v.string(),
});

const payloadSchema = v.object({
  fromUser: v.number(),
  toUser: v.number(),
  parentId: v.nullable(v.number()),
  childId: v.nullable(v.number()),
  path: v.string(),
  dateTime: v.nullable(v.string()),
  content: v.string(),
  extends: extendsSchema,
});

export type Notification = v.InferOutput<typeof notificationSchema>;
export const notificationSchema = v.object({
  _id: v.string(),
  package_uuid: v.string(),
  integer_id: v.string(),
  path: v.string(),
  redirect_link: v.string(),
  event: v.string(),
  event_at: v.string(),
  payload_version: v.string(),
  source: v.string(),
  payload: payloadSchema,
  is_read: zeroOrOne,
  is_viewed: zeroOrOne,
  created_at: v.string(),
  updated_at: v.string(),
});

const linkItemSchema = v.object({
  url: v.nullable(v.string()),
  label: v.string(),
  active: v.boolean(),
});

const metaSchema = v.object({
  current_page: v.number(),
  from: v.nullable(v.number()),
  last_page: v.number(),
  links: v.array(linkItemSchema),
  path: v.string(),
  per_page: v.number(),
  to: v.nullable(v.number()),
  total: v.number(),
});

const linksSchema = v.object({
  first: v.string(),
  last: v.string(),
  prev: v.nullable(v.string()),
  next: v.nullable(v.string()),
});

export type FetchNotificationsResponse = v.InferOutput<typeof fetchNotificationsResponseSchema>;
export const fetchNotificationsResponseSchema = v.object({
  data: v.array(notificationSchema),
  success: v.boolean(),
  links: linksSchema,
  meta: metaSchema,
});

export type ResetNotificationsResponse = v.InferOutput<typeof resetNotificationsResponseSchema>;
export const resetNotificationsResponseSchema = v.object({
  data: v.number(),
  success: v.boolean(),
  msg: v.string(),
});
